import { render, staticRenderFns } from "./FrequencyRenderer.vue?vue&type=template&id=012b6238&"
import script from "./FrequencyRenderer.vue?vue&type=script&lang=js&"
export * from "./FrequencyRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports